<template>
  <div>
    <v-row>
      <v-col cols="12">
        <TipoCalculo v-model="model" @changeTipoCalculo="changeTipoCalculo"/>
      </v-col>
      <v-col cols="12">
        <input-select label="Tipo de Operação" v-model="model.TipoOperacaoCred" @change="changeOperacao"
          :options="operacao" required />
      </v-col>
      <v-col cols="12">
        <input-select label="Produto" v-model="model.Produto" @change="changeProduto" :options="produtos" return-object
          required />
      </v-col>
    </v-row>
    <v-row v-if="enabledAmortizacao">
      <v-col cols="12">
        <input-select label="Tipo Imóvel" v-model="model.TipoImovel" :options="tiposImovel" return-object required @change="model.IsentarIOF = false"/>
      </v-col>
      <v-col cols="12" class="pt-0 mt-0" v-if="model.TipoImovel === 'Residencial' && isPF">
        <v-checkbox v-model="model.IsentarIOF" label="Isentar IOF" class="pt-0 mt-0"/>
      </v-col>
      <v-col cols="12">
        <input-select label="Divisão de Négocio" v-model="model.DivisaoNegocio" :options="['Desenvolvimento Urbano', 'Incorporação Vertical']" return-object
          required @change="changeDivisaoNegocio"/>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-label>Amortização</v-label>
        <input-radiogroup name="Amortização" row v-model="model.ModeloCalculo" required>
          <v-radio v-for="modelo in modelos" :key="modelo.value" :label="modelo.label" :value="modelo.value"/>
        </input-radiogroup>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-label>Modalidade</v-label>
        <input-radiogroup name="Indexador" row v-model="model.TipoIndexador" @change="changeIndexador" required>
          <v-radio label="Pré-Fixado" :value="1" />
          <v-radio label="Pós-Fixado" :value="2" />
        </input-radiogroup>
      </v-col>
      <v-col cols="6">
        <input-select label="Indexador Pós Fixado" v-model="model.TipoIndiceFinan"
          :options="indexadores" :disabled="model.TipoIndexador !== 2"
          :required="model.TipoIndexador === 2" />
      </v-col>
      <v-col cols="6">
        <input-number label="Percentual Indexador" v-model="model.PercIndiceFinan" format="percent"
          :disabled="model.TipoIndexador !== 2" :required="model.TipoIndexador === 2" />
      </v-col>
      <v-col cols="6">
        <input-number :label="labelJuros" v-model="model.TxJuros" precision="5" max="999.99999" format="percent"
          required />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: null,
    isPF: null
  },
  data () {
    return {
    }
  },
  computed: {
    modelos () {
      return this.$param.ModeloCalculoProduto[this.model.TipoContratoSigla]
    },
    indexadores () {
      const itens = this.$param.Indexadores[this.model.TipoContratoSigla]
      if (itens) {
        return itens
      } else {
        return this.$param.Indexadores.TODOS
      }
    },
    tiposImovel () {
      return ['Residencial', 'Comercial']
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    produtos () {
      if (this.model.TipoCalculoFluxo === this.$aux.TipoFluxoEnum.Irregular && this.model.TipoOperacaoCred === 3) return []
      const lista = this.$api.Estruturadas.GetProdutos(
        this.model.DocumentoFederal,
        this.model.TipoOperacaoCred,
        this.$param.EST_PRODUTOS
      );
      return lista;
    },
    operacao () {
      const tipoOperacao = this.$api.Estruturadas.GetTipoOperacaoByTipoPessoa(
        this.model.DocumentoFederal,
        this.$param.EST_PRODUTOS
      );
      return tipoOperacao;
    },
    enabledAmortizacao () {
      const th = this
      const index = th.$param.ProdutosSAC.findIndex(produto => (
        produto.PF === th.isPF || produto.PJ === !th.isPF) &&
        produto.TipoOperacao === th.model.TipoOperacaoCred &&
        produto.TipoContrato === th.model.TipoContratoSigla &&
        produto.TipoCalculo === th.model.TipoCalculoFluxo
      )
      return index >= 0
    },
    labelJuros () {
      return this.model.TipoContratoSigla === 'FI' ? 'Taxa de Juros a.a.' : 'Taxa de Juros a.m.'
    }
  },
  methods: {
    changeDivisaoNegocio (value) {
      const th = this
      if (value === 'Desenvolvimento Urbano') {
        th.$set(th.model, 'TipoCampoSeguroDFI', null)
        th.$set(th.model, 'VlrSeguroMensal2', null)
        th.$set(th.model, 'PercSeguroMensal2', null)
      }
    },
    changeIndexador () {
      const th = this;
      if (th.model.TipoIndexador === 1) {
        th.$set(th.model, 'TipoIndiceFinan', null)
        th.$set(th.model, 'PercIndiceFinan', '')
      }
    },
    changeOperacao (value) {
      this.$set(this.model, 'TipoOperacaoNome', null);
      if (value) { this.$set(this.model, 'TipoOperacaoNome', this.$api.Estruturadas.TipoOperacaoCred.find(p => p.value === value).text); }
      this.$set(this.model, 'DtDesembolso', null);
      this.$set(this.model, 'DtEmissao', null);
      this.$set(this.model, 'DtPrimeiroVencto', null);
      this.$set(this.model, 'TipoIndiceFinan', null);
      this.$set(this.model, 'Prazo', null);
      this.$set(this.model, 'Produto', null);
      this.$set(this.model, 'ModeloCalculo', null);
      this.$set(this.model, 'TipoIndexador', null);
      this.$set(this.model, 'TxJuros', null);
      this.$set(this.model, 'VlrAvaliacao', null);
      this.$set(this.model, 'VlrCadastro', null);
      this.$set(this.model, 'VlrCredito', null);
      this.clearAmortizacao()
    },
    changeProduto (item) {
      const th = this
      th.$set(th.model, 'TipoContrato', null)
      if (item && item.value) {
        th.$set(th.model, 'TipoContratoSigla', item.value)
        th.$set(th.model, 'TipoContratoTela', item.value)
        th.$set(th.model, 'TipoContratoDescricao', item.value + ' - ' + item.text)
      }
      if (item && item.value !== 'CPV') {
        th.$set(th.model, 'GarantiaSimulacao', [])
      }
      th.clearAmortizacao()
      if (item && item.value === 'FI') {
        th.$set(th.model, 'ModeloCalculo', th.$param.TipoAmortizacaoPadrao)
      }
    },
    changeTipoCalculo () {
      const th = this
      th.clearAmortizacao()
    },
    clearAmortizacao () {
      const th = this
      if (th.model.TipoContratoSigla === 'FI') {
        th.$set(th.model, 'ModeloCalculo', th.$param.TipoAmortizacaoPadrao)
      } else {
        th.$set(th.model, 'ModeloCalculo', th.$aux.ModeloCalculoEnum.Price)
      }
      th.$set(th.model, 'TipoImovel', null);
      th.$set(th.model, 'DivisaoNegocio', null);
      th.$set(th.model, 'IsentarIOF', null);
    }
  }
}
</script>
